import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationButton = _resolveComponent("NotificationButton")!
  const _component_NotificationList = _resolveComponent("NotificationList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NotificationButton, { "data-notification-button": "" }),
    _withDirectives(_createVNode(_component_NotificationList, {
      "data-notification-list": "",
      onCloseNotifications: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpened = false))
    }, null, 512), [
      [_vShow, _ctx.isOpened]
    ])
  ], 64))
}